module.exports = __webpack_public_path__ + "zmenseni-prsou_6_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zmenseni-prsou_6_before_tn.jpg
// module id = 1756
// module chunks = 0